module.exports = __webpack_public_path__ + "img/mall2.1c5cb43e.png";